export const SET_RESETMINED_TAB = "SET_RESETMINED_TAB";
export const SET_RESETLAB_TAB = "SET_RESETLAB_TAB";
export const SET_RESETFANCY_TAB = "SET_RESETFANCY_TAB";
export const SET_COMPARE_TAB_IDS = "SET_COMPARE_TAB_IDS";
export const SET_GEMSTONE_DETAILS = "SET_GEMSTONE_DETAILS";
export const SET_RESETREQUEST_TAB = "SET_RESETREQUEST_TAB";
export const SET_COMPARE_PAGE_KEY = "SET_COMPARE_PAGE_KEY";
export const SET_RESETMINED_TOGGLE = "SET_RESETMINED_TOGGLE";
export const SET_RESETLAB_TOGGLE = "SET_RESETLAB_TOGGLE";
export const SET_RESETFANCY_TOGGLE = "SET_RESETFANCY_TOGGLE";

//Mined Save and Reset
export const SET_SAVESEARCH_MINEDTAB = "SET_SAVESEARCH_MINEDTAB";
export const SET_SAVEFILTER_MINEDTAB = "SET_SAVEFILTER_MINEDTAB";
export const SET_SAVEEVERYTIME_MINEDTAB = "SET_SAVEEVERYTIME_MINEDTAB";
export const SET_SWITCHFILTER_MINEDTAB = "SET_SWITCHFILTER_MINEDTAB";